import { CallState, LodgingId, QuoteId, RoomInfoCfarQuote } from "redmond";
import {
  DefaultVariantType,
  HOTELS_CFAR,
  HOTEL_CFAR_REFUND_DISPLAY,
  HOTELS_LFAR,
  FINTECH_HOTEL_UX_UPDATED,
  HotelCfarRefundDisplayVariantType,
  HOTELS_CFAR_ELIGIBLE_POLICY,
  HotelsCfarEligiblePolicyPropVariantType,
  HOTEL_CFAR_RR_MULTIPLE_CANCELLATION_POLICIES,
  HOTEL_PD_BANNER_COPY,
  HotelPDBannerCopyVariantType,
  HOTEL_CFAR_MODEL_V1,
  LDJSONConfig,
  HOTEL_CFAR_ROOM_ID_MATCH,
  HOTEL_CFAR_PASS_OPAQUE_PARAM,
  HOTELS_TAXES_AND_FEES_EXPERIMENT,
  HotelsTaxesAndFeesVariantType,
  HOTEL_CFAR_LANGUAGE_EXPERIMENT,
  HBUX_LODGING_ERROR_COPY_UPDATE,
} from "../../../context/experiments";
import { actions, actionTypes } from "../actions";
import {
  actions as hotelShopActions,
  actionTypes as hotelShopActionTypes,
} from "../../shop/actions";

export const DO_NOT_APPLY_OPTION_KEY = "do-not-apply-option";

export interface IHotelAncillaryExperiments {
  [HOTELS_CFAR]: DefaultVariantType;
  [HOTEL_CFAR_REFUND_DISPLAY]: HotelCfarRefundDisplayVariantType;
  [HOTELS_CFAR_ELIGIBLE_POLICY]: HotelsCfarEligiblePolicyPropVariantType;
  [HOTELS_LFAR]: DefaultVariantType;
  [FINTECH_HOTEL_UX_UPDATED]: DefaultVariantType;
  [HOTEL_PD_BANNER_COPY]: HotelPDBannerCopyVariantType;
  [HOTEL_CFAR_RR_MULTIPLE_CANCELLATION_POLICIES]: DefaultVariantType;
  [HOTEL_CFAR_MODEL_V1]: LDJSONConfig | null;
  [HOTEL_CFAR_ROOM_ID_MATCH]: DefaultVariantType;
  [HOTEL_CFAR_PASS_OPAQUE_PARAM]: DefaultVariantType;
  [HOTELS_TAXES_AND_FEES_EXPERIMENT]: HotelsTaxesAndFeesVariantType;
  [HOTEL_CFAR_LANGUAGE_EXPERIMENT]: DefaultVariantType;
  [HBUX_LODGING_ERROR_COPY_UPDATE]: DefaultVariantType;
}
export interface IHotelAncillaryExperimentState {
  experiments: IHotelAncillaryExperiments | null;
}

export interface IHotelAncillaryState extends IHotelAncillaryExperimentState {
  lodgingId: LodgingId | null;
  roomInfoCfarQuotes: RoomInfoCfarQuote[];
  fetchCfarQuoteCallState: CallState;
  selectedCfarId: QuoteId | null;
  selectedHtsCfarOfferId: string | null;
  hasSelectedRefundableRoom: boolean;
  shouldDisableRefundableRooms?: boolean;
  hasAddedCfarFromModal?: boolean;
}

export const initialState: IHotelAncillaryState = {
  experiments: null,
  lodgingId: null,
  roomInfoCfarQuotes: [],
  fetchCfarQuoteCallState: CallState.NotCalled,
  selectedCfarId: null,
  selectedHtsCfarOfferId: null,
  hasSelectedRefundableRoom: false,
};

export const getExperimentState = (
  hotelAncillaryState: IHotelAncillaryState | undefined
): IHotelAncillaryExperimentState => {
  return {
    experiments: hotelAncillaryState?.experiments ?? initialState.experiments,
  };
};

export function reducer(
  state: IHotelAncillaryState = initialState,
  action: actions.HotelAncillaryActions | hotelShopActions.ISetSelectedRoomId
): IHotelAncillaryState {
  switch (action.type) {
    case actionTypes.SET_ANCILLARY_EXPERIMENTS:
      return {
        ...state,
        experiments: action.experiments,
      };
    case actionTypes.FETCH_CFAR_QUOTES:
      return {
        ...state,
        lodgingId: null,
        selectedCfarId: null,
        selectedHtsCfarOfferId: null,
        hasSelectedRefundableRoom: false,
        roomInfoCfarQuotes: [],
        fetchCfarQuoteCallState: CallState.InProcess,
      };
    case actionTypes.SET_FETCH_CFAR_QUOTES_CALL_STATE_FAILED:
      return {
        ...state,
        fetchCfarQuoteCallState: CallState.Failed,
      };
    case actionTypes.SET_CFAR_QUOTES:
      return {
        ...state,
        fetchCfarQuoteCallState: CallState.Success,
        lodgingId: action.response.lodgingId,
        roomInfoCfarQuotes: action.response.roomInfoCfarQuotes,
        shouldDisableRefundableRooms:
          action.response.shouldDisableRefundableRooms,
      };
    case actionTypes.SET_SELECTED_CFAR_ID:
      return {
        ...state,
        selectedCfarId: action.cfarId,
      };

    // Need to reset selected HTS CFAR offer ID when room changes from the hotel shop module
    case hotelShopActionTypes.SET_SELECTED_ROOM_ID:
      return {
        ...state,
        selectedHtsCfarOfferId: null,
      };

    case actionTypes.SET_SELECTED_HTS_CFAR_OFFER_ID: {
      return {
        ...state,
        selectedHtsCfarOfferId: action.selectedHtsCfarOfferId,
      };
    }
    case actionTypes.SET_HAS_SELECTED_REFUNDABLE_ROOM:
      return {
        ...state,
        hasSelectedRefundableRoom: action.hasSelectedRefundableRoom,
      };

    case actionTypes.SET_HAS_ADDED_CFAR_FROM_MODAL:
      return {
        ...state,
        hasAddedCfarFromModal: action.hasAddedCfarFromModal,
      };
    default:
      return state;
  }
}

export * from "./selectors";
